(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["commerce-script"] && !Shopify.designMode) return;
  try {
    function initializeFruityProducts(scope = document) {
  scope.querySelectorAll('[data-fd-product]').forEach((container) => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';
    const variantSelect = container.querySelector('[data-fd-variant]');
    const image = container.querySelector('.fd-product__image');
    const zoom = container.querySelector('[data-fd-zoom]');
    const zoomImage = container.querySelector('.fd-product__zoom-image');
    container.querySelector('[data-fd-zoom-open]')?.addEventListener('click', () => zoom?.showModal());
    container.querySelector('[data-fd-zoom-close]')?.addEventListener('click', () => zoom?.close());
    zoom?.addEventListener('click', (event) => { if (event.target === zoom) zoom.close(); });
    const setImage = (src, alt) => {
      if (!image || !src) return;
      image.removeAttribute('srcset');
      image.src = src;
      image.alt = alt || '';
      if (zoomImage) { zoomImage.removeAttribute('srcset'); zoomImage.src = src; zoomImage.alt = alt || ''; }
    };
    const updateVariant = (updateUrl = false) => {
      const option = variantSelect?.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const addButton = container.querySelector('[data-fd-add]');
      const compare = container.querySelector('[data-fd-compare]');
      container.querySelector('[data-fd-price]').textContent = option.dataset.price;
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      addButton.disabled = !available;
      const payments = container.querySelector('[data-fd-payments]');
      if (payments) payments.hidden = !available;
      addButton.textContent = available ? container.dataset.addLabel : container.dataset.soldLabel;
      container.querySelector('[data-fd-availability]').textContent = available ? container.dataset.availableLabel : container.dataset.soldLabel;
      const quantity = container.querySelector('[data-fd-quantity]');
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      setImage(option.dataset.image, option.dataset.imageAlt);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
    };
    variantSelect?.addEventListener('change', () => updateVariant(true));
    container.querySelectorAll('[data-fd-image-src]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        setImage(link.dataset.fdImageSrc, link.dataset.fdImageAlt);
        container.querySelectorAll('[data-fd-image-src]').forEach((thumb) => thumb.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
      });
    });
    updateVariant();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeFruityProducts());
else initializeFruityProducts();
document.addEventListener('shopify:section:load', (event) => initializeFruityProducts(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-purchase"] && !Shopify.designMode) return;
  try {
    function initializeFruityMobilePurchase(scope = document) {
  scope.querySelectorAll('[data-fd-mobile-purchase]').forEach((bar) => {
    if (bar.fruityMobileCleanup) return;
    const form = document.getElementById(bar.dataset.formId);
    const container = form?.closest('[data-fd-product]');
    const addButton = form?.querySelector('[data-fd-add]');
    const price = container?.querySelector('[data-fd-price]');
    const mobilePrice = bar.querySelector('[data-fd-mobile-price]');
    if (!form || !addButton || !price || !mobilePrice) return;
    const syncPrice = () => { mobilePrice.textContent = price.textContent; };
    syncPrice();
    const priceObserver = new MutationObserver(syncPrice);
    priceObserver.observe(price, { childList: true, characterData: true, subtree: true });
    let visibilityObserver;
    if ('IntersectionObserver' in window) {
      let addVisible = false;
      let footerVisible = false;
      const footer = document.querySelector('footer.footer');
      visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === addButton) addVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        bar.hidden = addVisible || footerVisible;
      });
      visibilityObserver.observe(addButton);
      if (footer) visibilityObserver.observe(footer);
    }
    bar.fruityMobileCleanup = () => {
      priceObserver.disconnect();
      visibilityObserver?.disconnect();
      delete bar.fruityMobileCleanup;
    };
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeFruityMobilePurchase());
else initializeFruityMobilePurchase();
document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('[data-fd-mobile-purchase]').forEach((bar) => bar.fruityMobileCleanup?.());
  initializeFruityMobilePurchase();
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-fd-mobile-purchase]').forEach((bar) => bar.fruityMobileCleanup?.());
});
  } catch(e) { console.error(e); }
})();

})();
